import { createFeatureSelector } from '@ngrx/store'
import {DashboardState } from '../state/dashboard.state'

export const getUserDashboardState = createFeatureSelector<DashboardState>('dashboard')
